import { render, staticRenderFns } from "./CreateForBoutique.vue?vue&type=template&id=42784556&"
import script from "./CreateForBoutique.vue?vue&type=script&lang=js&"
export * from "./CreateForBoutique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports